import { api, LightningElement } from "lwc";

import { ContentSummaryConfig, ContentSummary } from "tds/contentSummary";

import { lightenHex } from "../../../shared/color";

const DEFAULT_BACKGROUND_HEIGHT = 80;

export default class extends LightningElement {
  @api imgSrc: string | null = null;
  @api titleHeadingLevel: "1" | "2" | "3" | "4" | null = null;
  @api summary: ContentSummary | null = null;

  private get config(): ContentSummaryConfig {
    return {
      imageSize: "large",
      titleMode: "text",
      titleHeadingLevel: this.titleHeadingLevel ?? undefined,
      variant: "tile",
    };
  }

  private get headerStyle() {
    return [
      `--tds-content-header_background-height-default: ${this.backgroundHeight}px`,
      `--tds-content-header_content-offset-top-default: ${this.contentOffset}px`,
    ].join(";");
  }

  private get backgroundHeight() {
    if (this.imgSrc) return 160;
    if (this.isTrailmix) return 90;
    return DEFAULT_BACKGROUND_HEIGHT;
  }

  private get backgroundStyle() {
    let { summary } = this;
    if (!summary) return "";
    let styles: string[] = [];
    if (this.imgSrc) styles.push(`background-image: url(${this.imgSrc})`);
    let { color } = summary;
    if (color && /^#/.test(color))
      styles.push(`background-color: ${lightenHex(color, -0.08)}`);
    return styles.join(";");
  }

  private get contentOffset() {
    if (this.isTrailmix) return -76;
    return -DEFAULT_BACKGROUND_HEIGHT;
  }

  private get isTrailmix() {
    return this.summary && this.summary.type === "trailmix";
  }

  private onNavigate() {
    this.dispatchEvent(
      new CustomEvent("navigate", {
        detail: this.summary!,
      })
    );
  }
}
